<template>
    <div>
        案件详情
    </div>
</template>

<script>
    export default {
        name: "caseDetails"
    }
</script>

<style scoped>

</style>
